import { ErrorBoundary } from '@sentry/react';

export default ErrorBoundary;
